// 从CDN加载FFmpeg
const script = document.createElement('script');
script.src = 'https://unpkg.com/@ffmpeg/ffmpeg@0.12.15/dist/umd/ffmpeg.js';
script.async = true;
document.head.appendChild(script);


//////////////////
// WEBPACK FOOTER
// ./static/ffmpeg-cdn.js
// module id = u4hq
// module chunks = 9